import type { UnitMode } from "~/domains/userPreferences/types/UnitMode";
import type { SearchDisplayMode } from "~/features/search/models/models";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { patchSessionUserPreferences } from "~/app/api/pageData";

interface SRPPreferencesApi {
  view: SearchDisplayMode;
  unit: UnitMode;
}

export const apiUpdateUserPreferences = (updates: Partial<SRPPreferencesApi>) => {
  const url = occUrl("/preferences/updatePreferences");
  const body = {
    unit: updates.unit,
    searchView: updates.view,
  };

  return occFetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (response.ok) {
      patchSessionUserPreferences({
        ...(updates.unit === undefined ? {} : { unit: updates.unit }),
        ...(updates.view === undefined ? {} : { searchView: updates.view }),
      });
    }
    return response;
  });
};
